/**
 * TypeScript mirror of the `--z-*` custom properties in styles/base/z-layers.scss.
 *
 * Use this for inline styles, portals and library configuration (PrimeReact's z-index bases); use
 * `var(--z-*)` — including Tailwind's `z-[var(--z-popup)]` — everywhere CSS can be written. Keep the
 * two files in step: the SCSS file is the documentation, this is the same scale for JS.
 */
export const Z_LAYERS = {
  stickyCell: 10,
  tabs: 20,
  tabsAbove: 30,
  menuFlyout: 900,
  panel: 1100,
  popup: 2000,
  overlay: 3000,
  fullscreen: 10000,
  tooltip: 10001,
  toast: 40000,
  banner: 1000100,
} as const;

export type ZLayer = keyof typeof Z_LAYERS;

export default Z_LAYERS;
